import { render, staticRenderFns } from "./DetalleAgendamientoCliente.vue?vue&type=template&id=57a59710&scoped=true&"
import script from "./DetalleAgendamientoCliente.vue?vue&type=script&lang=js&"
export * from "./DetalleAgendamientoCliente.vue?vue&type=script&lang=js&"
import style0 from "./DetalleAgendamientoCliente.vue?vue&type=style&index=0&id=57a59710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a59710",
  null
  
)

export default component.exports